// extracted by mini-css-extract-plugin
export default {"link":"SettingPage_link__yxbB4","linkActive":"SettingPage_linkActive__T3tGN"};